import "./Library.module.css";
import Header from "@/reusable_sections/Header";
import PublishedWorks from "./sections/PublishedWorks";
import LatestInsights from "./sections/LatestInsights";
import Footer from "@/reusable_sections/Footer";
export default function LibraryPage() {
  return <div>
      <Header />
      <PublishedWorks />
      <LatestInsights />
      <Footer />
    </div>;
}